import { Intent } from "@blueprintjs/core";
import { ButtonWithDialog } from "@focus/focusUI";
import { useState } from "react";
import { usePhonebook } from "../../hooks/usePhonebook";
import { ROLES, useRoles } from "../../hooks/useRoles";
import type { Organization } from "../../types/phonebook";
import { PhonebookOrganizationForm } from "./PhonebookOrganizationForm";

export const CreateOrganizationButton = () => {
  const { addOrganization } = usePhonebook();
  const { roles } = useRoles();
  const [acceptDisabled, setAcceptDisabled] = useState<boolean>(true);

  const isAdmin = roles.includes(ROLES.ADMIN);

  if (!isAdmin) return null; // Do not show button

  const emptyOrganization: Organization = {
    name: "",
    orgRole: "",
    address: "",
    phoneNumber: "",
    email: "",
    notes: "",
  };

  return (
    <ButtonWithDialog
      minimal
      icon="inherited-group"
      tooltipText="New organization"
      intent={Intent.NONE}
      defaultContent={emptyOrganization}
      onAccept={(newOrganization) => addOrganization(newOrganization)}
      form={({ content, onUpdate }) => (
        <PhonebookOrganizationForm
          content={content}
          onUpdate={onUpdate}
          onValidityChange={(isValid) => setAcceptDisabled(!isValid)}
          canEditRestrictedOrgFields={isAdmin}
          readOnly={false}
        />
      )}
      disableAccept={acceptDisabled}
    />
  );
};
